import { Box } from '@mui/material';
import React from 'react';
import Footer from '../../Shared/Footer/Footer';
import Navigation from '../../Shared/Navigation/Navigation';
import Announcements from '../Announcements/Announcements';
import Banner from '../banner/Banner/Banner';
import Luminous from '../luminous/Luminous/Luminous';
import Message from '../Message/Message';
import Quote from '../Quote/Quote';
import usePageMeta from '../../../hooks/usePageMeta';

const Home = () => {
	usePageMeta({
		title: "外国人人材紹介・採用支援",
		description: "株式会社エムアイジャパンは、日本人・外国人に特化した人材紹介を行う有料職業紹介事業者です。世界中から優秀なIT人材・労働者を発掘し、日本の人材不足の解決をお手伝いします。",
		path: "/",
	});
	return (
		<Box>
			<Navigation />
			<Banner />
			<Luminous />
			<Message />
			<Quote />
			<Announcements />

			<Footer />
		</Box>
	);
};

export default Home;